const validatePersonalausweis = (id: string): boolean => {
  if (/^\d{10}$/.test(id)) {
    return true
  }

  // Check if the input starts with one of the allowed letters and is followed by 8 valid characters
  const letterRegex = /^[LMNPRTVWXYZ]$/i // Case-insensitive regex for the first letter
  const validCharRegex = /^[CDEFGHJKLMNOPQRSTUVWXYZ0-9]{8}$/i // Case-insensitive regex for the following characters

  if (
    letterRegex.test(id.charAt(0)) &&
    id.substring(1).length === 8 &&
    validCharRegex.test(id.substring(1))
  ) {
    return true
  }

  return false
}
export default validatePersonalausweis
